import AdbIcon from './src/icon.vue';

AdbIcon.install = function (Vue) {
  Vue.component(AdbIcon.name, AdbIcon);
};

export default AdbIcon;
